export const PUBLIC_SITE_CHROME = {
  nav: {
    ariaLabel: 'Public navigation',
    brandHomeSuffix: 'home',
    contact: 'Contact',
    console: 'Console',
    getStarted: 'Get started',
    languageLabel: 'Language',
    languageAriaLabel: 'Website language',
  },
  common: {
    openWorkspace: 'Open my workspace',
    openConsole: 'Open Console',
    console: 'Console',
    featureColumnHeader: 'Feature',
    capabilityColumnHeader: 'Capability',
    creditsLabel: 'Credits',
    storageLabel: 'Storage',
  },
  overview: {
    dataEyebrow: 'What you create',
    dataTitle: 'The app data has a simple shape.',
    visualGoal: 'Goal',
    visualTask: 'Task',
    visualSubtask: 'Subtask',
    visualChecklist: 'Checklist',
    visualAi: 'AI',
    visualTeam: 'Team',
    visualDraft: 'Draft',
    visualReview: 'Review',
    visualSave: 'Save',
    clickEyebrow: 'Where to click',
    clickTitle: 'Short guides for actions that need a visual cue.',
    workflowEyebrow: 'Examples',
    workflowTitle: 'Realistic ways to structure work.',
    mediaEyebrow: 'Images and motion',
    mediaTitle: 'Some actions deserve a small clip.',
    mediaIntro: 'These slots are prepared for safe demo screenshots, short WebM/MP4 clips, or tiny GIFs captured from debug/demo workspaces.',
    mediaFallback: 'Open GIF fallback',
    screenshotEyebrow: 'Visual examples',
    screenshotTitle: 'Full-page examples without private data.',
    storyAriaLabel: 'Timelining story',
    docsFaqPreviewAriaLabel: 'Docs and FAQ preview',
    faqPreviewLabel: 'FAQ',
    faqPreviewTitle: '25 questions grouped by topic',
    featureEyebrow: 'What is inside',
    featureTitle: 'Everything has a place, but nothing feels boxed in.',
  },
  docs: {
    eyebrow: 'Guidebook',
    keyboardEyebrow: 'Keyboard',
    tipsTitle: "Quick tips from people who've built this way",
  },
  faq: {
    eyebrow: 'FAQ',
    title: '25 answers before you sign up.',
    intro: "Grouped by what you're actually wondering about — getting started, AI Magic, the gamification loop, teams and roles, and data and privacy.",
  },
  about: {
    eyebrow: 'About',
    principlesEyebrow: 'Principles',
    principlesTitle: 'What we optimize for.',
    fitEyebrow: 'Fit',
    goodFit: 'Good fit',
    notRightTool: 'Not the right tool',
    statusEyebrow: 'Status',
    statusTitle: 'Shipped and next.',
  },
  pricing: {
    eyebrow: 'Pricing',
    tierAriaLabel: 'Timelining pricing tiers',
    economyCreditLabel: 'Credits',
    economyStorageLabel: 'Storage',
    comparisonAriaLabel: 'Tier feature comparison',
    faqEyebrow: 'Pricing FAQ',
    faqTitle: 'Before you enter a card number.',
    localeLabel: 'Language',
    localeAriaLabel: 'Language and currency',
    currencyNoteFallback: 'Prices shown are {currency}. Auto-conversion is planned — for now, contact us for a manual quote in this currency.',
  },
  contact: {
    eyebrow: 'Contact',
    nameLabel: 'Your name',
    namePlaceholder: 'Real name works best',
    emailLabel: 'Email',
    emailPlaceholder: 'you@company.com',
    topicLabel: 'Topic',
    messageLabel: 'Message',
    messagePlaceholder: "Context, what you're trying to do, what would help.",
    sendMessage: 'Send message',
    directPrefix: 'Prefer email? Write directly to',
    walkthroughSubject: 'Walkthrough request',
    topicExpectationsTitle: 'What to expect from each topic',
    mailtoFallbackTopic: 'Contact',
    mailtoFallbackName: 'Timelining site',
  },
  solutions: {
    eyebrow: 'Solutions',
    title: 'Six real setups. Copy the shape.',
    intro: "Every card below is a workspace configuration that actually works — the setup, the daily loop, and the one thing this app does that others can't.",
    setup: 'Setup',
    dailyLoop: 'Daily loop',
    difference: "What's different here",
  },
  resources: {
    eyebrow: 'Resources',
    recipeAriaSuffix: 'recipes',
    recipeHeadingSuffix: 'recipes',
    promptEyebrow: 'Prompt library',
    categories: {
      delivery: 'Delivery',
      creative: 'Creative',
      personal: 'Personal',
      ops: 'Ops',
    },
  },
  cta: {
    signedInPrimary: 'Open my workspace',
  },
  download: {
    cards: {
      member: {
        audience: 'Members, admins, editors, viewers',
        title: 'Timelining Member',
        body: 'Full workspace on your phone — For You, chat, checklists, AI Magic, calendar. Sign in with the same account you use in the Console.',
        callout: 'Sign in with Google after installing.',
      },
      helper: {
        audience: 'Field helpers only',
        title: 'Timelining Helper',
        body: 'Narrow shell for people executing assigned checklists — proof upload, comments, status. Helpers only see workspaces they are invited into.',
        callout: 'Ask a workspace admin for an invite. The app is unusable without one.',
      },
    },
    shareTitleMember: 'Install Timelining Member',
    shareTitleHelper: 'Install Timelining Helper',
    shareText: 'Install the Timelining Android app from this testing link.',
    copiedStatus: 'Download link copied.',
    copyUnavailableStatus: 'Copy is not available in this browser.',
    sharedStatus: 'Share sheet opened.',
    shareCopiedStatus: 'Share is not available — copied instead.',
    shareFailedStatus: 'Share failed. Copy the link and send it yourself.',
    directLink: 'Direct link:',
    latestPublished: 'Latest published:',
    manifestPending: 'Latest published version will appear here once a build is on the store bucket.',
    downloadApk: 'Download APK',
    copyLink: 'Copy link',
    share: 'Share',
    eyebrow: 'Get Timelining',
    title: 'Install the Android apps.',
    intro: 'The web Console runs in any modern browser. The phone experience ships as two Android apps — one for the full workspace, one for the field-helper shell. Sign in with the same account you use in the Console.',
    cardsAriaLabel: 'Download the phone apps',
    tipsEyebrow: 'Install tips',
    tipsTitle: 'Sideloading on Android',
    tips: [
      {
        title: '1. Open the link on your phone',
        body: "Copy the download link from this page and open it in your phone's browser. If your desktop and phone share a browser account (Chrome, Edge) the tab can also be sent straight to the phone.",
      },
      {
        title: '2. Allow install from this source',
        body: 'Android asks once per browser for permission to install unknown apps. Grant it to the browser you downloaded with, then re-open the APK from your Downloads.',
      },
      {
        title: '3. Sign in and open your workspace',
        body: 'The Member app uses Google sign-in; the Helper app uses your phone number and needs an active invite from an admin. Updates install automatically after the first launch — no need to re-download the APK for every release.',
      },
    ],
  },
} as const
